import React from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
    languageChange,
    currentSelectedLanguage,
  } from "../../../StateManagement/actions";
const WarnUnSaveChangesPopUp = ({ isOpen, onCancel, onConfirm }) => {
    const selectedLanguage = useSelector(currentSelectedLanguage);
    if (!isOpen) return null;

    return (        
            <div className="modalCus" id="myModal">
              <div className="Settingmodal-dialog  modal-dialog-centered">
                <div className="modal-content">
                  {/* <div className="modal-body justify-content-center d-flex mt-2">
                    <img
                      src="assets/img/icons/folder.png"
                      alt=""
                      className="h-90p"
                    />
                  </div> */}
                  <div className="mleft15 justify-content-center mb-3 modalheaederleft">
                    <h4 className="mb-2 mt-2 text-danger fw-bold" htmlFor="">
                      {selectedLanguage.LstLanguageCodes.UI_Settings}
                    </h4>
                  </div>
                  <hr className="modalhorizontal" />
                  <div
                    className="d-flex justify-content-center flex-column mb-3 text-center"
                    style={{ marginTop: "20px" }}
                  >
                    {/* <p
                      className="w-100 f-w550 mb-1 res-px10"
                      style={{ display: "content" }}
                    >
                      {
                        selectedLanguage.LstLanguageCodes
                          .UI_Thiswilldeletethedocrecord
                      }
                    </p> */}
                    <p
                      className="w-100 f-w550"
                      style={{ display: "content", fontSize: "18px" }}
                    >
                      {selectedLanguage.LstLanguageCodes.UI_ConfirmMessage}
                    </p>
                  </div>
                  <div className="d-flex justify-content-center mb-4 ">
                    <button
                      type="button"
                      className="btn btn-danger px-4 me-1"
                      data-bs-dismiss="modal"
                      onClick={onCancel}
                    >
                      {selectedLanguage.LstLanguageCodes.UI_Cancel}
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary px-4 ms-3"
                      onClick={onConfirm}
                    >
                      {selectedLanguage.LstLanguageCodes.UI_Confirm}
                    </button>
                  </div>
                </div>
              </div>
            </div>         
    );
};
export default WarnUnSaveChangesPopUp;